import axios from "@/api/axios";

const search_upd = (upd_number) => {
  return axios.get("/api/upds/" + upd_number);
};

const create_upd = (upd) => {
  return axios.post("/api/checks", upd);
};

const reject_upd = (search_number) => {
  return axios.post("/api/upds/" + search_number + "/reject", {});
};

export default {
  search_upd,
  create_upd,
  reject_upd,
};
